import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Kicker, Tag, ImageWithCredit } from "@/components/site/primitives";
import { NEWS } from "@/content/worldFarmers";

export const News = () => {
  const featured = NEWS.find((n) => n.featured) || NEWS[0];
  const rest = NEWS.filter((n) => n.id !== featured.id);
  return (
    <section id="news" aria-labelledby="news-heading" className="wf-section bg-[var(--wf-paper)]">
      <div className="wf-container">
        <Reveal className="max-w-2xl">
          <Kicker>In the news</Kicker>
          <h2 id="news-heading" className="mt-3 font-serif text-3xl font-semibold text-[var(--wf-ink)] sm:text-4xl">
            Announcements &amp; stories
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* Featured */}
          <Reveal className="lg:col-span-7">
            <a
              href={featured.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="news-featured-card"
              className="group flex h-full flex-col overflow-hidden rounded-sm border border-[var(--wf-border)] bg-[var(--wf-cream)] shadow-[var(--wf-shadow-sm)] transition-[box-shadow,transform] duration-300 hover:shadow-[var(--wf-shadow)] motion-safe:hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background"
            >
              <ImageWithCredit src={featured.image} alt={featured.alt} className="aspect-[16/9]" imgClassName="transition-transform duration-500 motion-safe:group-hover:scale-[1.03]" interactive={false} />
              <div className="flex flex-1 flex-col p-6">
                <div className="flex items-center gap-3">
                  <Tag tone="green">{featured.category}</Tag>
                  <span className="text-xs text-muted-foreground">{featured.date}</span>
                </div>
                <h3 className="mt-3 font-serif text-2xl font-semibold text-[var(--wf-ink)] group-hover:text-[var(--wf-maroon)]">
                  {featured.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-muted-foreground">{featured.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[var(--wf-maroon)]">
                  Read more <ArrowUpRight className="h-4 w-4 motion-safe:transition-transform motion-safe:group-hover:translate-x-0.5 motion-safe:group-hover:-translate-y-0.5" aria-hidden="true" />
                </span>
              </div>
            </a>
          </Reveal>

          {/* Secondary list */}
          <div className="flex flex-col gap-5 lg:col-span-5">
            {rest.map((n, idx) => (
              <Reveal key={n.id} delay={0.08 * (idx + 1)}>
                <a
                  href={n.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="news-item-card"
                  className="group flex gap-4 rounded-sm border border-[var(--wf-border)] bg-[var(--wf-cream)] p-3 shadow-[var(--wf-shadow-sm)] transition-[box-shadow,transform] duration-300 hover:shadow-[var(--wf-shadow)] motion-safe:hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background"
                >
                  <img src={n.image} alt={n.alt} loading="lazy" className="h-24 w-28 shrink-0 rounded-lg object-cover" />
                  <div className="flex flex-col">
                    <div className="flex items-center gap-2">
                      <Tag tone="green" className="px-2 py-0.5 text-[10px]">{n.category}</Tag>
                      <span className="text-[11px] text-muted-foreground">{n.date}</span>
                    </div>
                    <h3 className="mt-1.5 font-serif text-base font-semibold leading-snug text-[var(--wf-ink)] group-hover:text-[var(--wf-maroon)]">
                      {n.title}
                    </h3>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
